// Hardcoded PA (Pennsylvania) dummy API response data, used only when running on
// localhost (see src/utils/devMode.js's isLocalDevMode) so the app is fully usable
// end-to-end without a working proxy/backend connection. These payloads are real
// sample responses captured from the PA (environmentId "28") plan and are meant to be
// representative of actual API shapes for: provider search results, facets, plan
// features, browse-by specialties, and fuzzy (type-ahead) search suggestions.

// ── Provider search response (POST /hcb/v3/providersearch/providers/.../search) ──
export const dummyPaSearchResponse = {
  page: 0,
  size: 5,
  totalRecords: 38,
  totalPages: 8,
  results: [
    {
      lastName: "EINSTEIN MEDICAL CENTER MONTGOMERY",
      firstName: "",
      providerDesignation: "",
      providerType: "HOSPITAL",
      provSex: "",
      provClass: "INSTITUTION",
      npi: "1104192590",
      email: "info@einsteinmed.org",
      url: "www.einsteinmed.org",
      language: "English, Interpreter Service",
      hospCred: "-1",
      splNeeds1: "",
      splNeeds2: "",
      specialNeedsChronicIllness: "",
      specialNeedsCooccurringDisorders: "",
      specialNeedsDeafHardOfHearing: "",
      specialNeedsHomelessness: "",
      treatmentOfHepC: "",
      treatmentOfHIVAIDS: "",
      stateLicenseNumber: "",
      chronicIllness: "",
      endStateRenalDiseaseESRD: "",
      seriousMentalIllness: "",
      culturalCompetencyTraining: "",
      provTier: "",
      asamLocDescriptions: "",
      specialNeedsTrauma: "",
      specialNeedsChildWelfare: "",
      specialNeedsSubstanceAbuse: "",
      acceptsMedicaid: "",
      specialTraining: "",
      afterHoursContactInfo: "",
      specializedExpertise: "",
      onecare: "",
      ethnicity: "NO ETHNICITY",
      medicationAssistedTreatment: "",
      matPrescribers: "",
      screeningBriefInterventionReferral: "",
      culturallyResponsiveCareChampion: "",
      lgbtResponsiveCareChampion: "",
      culturallyResponsivePrimaryCareBehavioralHealth: "",
      culturallyResponsiveMaternalMentalHealth: "",
      indianHealthServiceProvider: "",
      rating: "",
      ccbHcProvider: "",
      culturalCompetencyFlag: "",
      vaccinesForChildren: "",
      personCenteredCareChampion: "",
      healthyAgingCareChampion: "",
      womensHealthCareChampion: "",
      cshcsProvider: "",
      pcmhCertification: "",
      race: "",
      locations: [
        {
          planProvId: "QXIPQ0000065046",
          provPhyAddr1: "559 W Germantown Pike",
          provPhyAddr2: "",
          provPhyCity: "Norristown",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19403",
          phone: "(484) 622-1000 ",
          fromMonday: "",
          toMonday: "",
          fromTuesday: "",
          toTuesday: "",
          fromWednesday: "",
          toWednesday: "",
          fromThursday: "",
          toThursday: "",
          fromFriday: "",
          toFriday: "",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "",
          affiliation: "",
          affilType: "",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "-1",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "N",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "559 W Germantown Pike, Norristown, PA, 19403",
          latitude: 40.152773,
          longitude: -75.343143,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 3.3
        },
        {
          // Second location added purely so this first mock result has MIXED
          // newAssigns values across its locations (this one "0" = not
          // accepting, vs. "-1" = accepting above) — that mismatch is what
          // triggers acceptingNewPatientsStatus === 'some' in
          // providerSummary.jsx, which renders the "Some locations" tag under
          // "Accepting new patients" instead of the plain all/none states.
          planProvId: "QXIPQ0000065047",
          provPhyAddr1: "100 Medical Plaza Dr",
          provPhyAddr2: "Suite 200",
          provPhyCity: "Norristown",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19401",
          phone: "(484) 622-2000 ",
          fromMonday: "",
          toMonday: "",
          fromTuesday: "",
          toTuesday: "",
          fromWednesday: "",
          toWednesday: "",
          fromThursday: "",
          toThursday: "",
          fromFriday: "",
          toFriday: "",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "",
          affiliation: "",
          affilType: "",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "0",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "N",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "100 Medical Plaza Dr, Suite 200, Norristown, PA, 19401",
          latitude: 40.155,
          longitude: -75.345,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 3.6
        }
      ],
      environmentId: "28",
      provId: "QXIPQ0000065046",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Hospital", boardCertifiedFlag: "" }
      ],
      distanceInMiles: 3.3,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "QXIPQ0000065046",
          primarySpecialty: "HOSPITAL",
          primarySpecialtyBoardCertified: false,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "QXIPQ0000065046", affilType: "SERVICE", affiliateName: "EINSTEIN MEDICAL CENTER MONTGOMERY", affiliateFax: null },
        { environmentId: "28", provId: "QXIPQ0000065046", affilType: "DIRECT", affiliateName: "EINSTEIN MEDICAL CENTER MONTGOMERY", affiliateFax: null }
      ],
      accreditations: [
        {
          environmentId: "28",
          provId: "QXIPQ0000065046",
          accreditingOrgName: "The Joint Commission",
          accreditingOrgUrl: "https://www.qualitycheck.org/quality-report/?keyword=EINSTEIN%20MEDICAL%20CENTER%20MONTGOMERY&bsnid=467998"
        }
      ],
      hospitals: [
        {
          environmentId: "28",
          provId: "QXIPQ0000065046",
          accreditingOrgName: "Hospital Quality Data",
          accreditingOrgUrl: "https://healthcarequality.mhcc.maryland.gov/MarylandHospitalCompare/index.html#/professional/quality-ratings/profile/13021"
        }
      ]
    },
    {
      lastName: "RENAL CARE GROUP EAST INC",
      firstName: "",
      providerDesignation: "",
      providerType: "HOSPITAL",
      provSex: "",
      provClass: "INSTITUTION",
      npi: "1780789586",
      email: "info@renalcaregroup.com",
      url: "www.eastern-nephrology-associates-renal-care-group.example-health-systems.com",
      language: "English, Interpreter Service",
      hospCred: "-1",
      stateLicenseNumber: "",
      specialTraining: "",
      ethnicity: "NO ETHNICITY",
      race: "",
      locations: [
        {
          planProvId: "QMX000000084737",
          provPhyAddr1: "1350 Powell St",
          provPhyAddr2: "",
          provPhyCity: "Norristown",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19401",
          phone: "(610) 277-7535 ",
          fromMonday: "",
          toMonday: "",
          fromTuesday: "",
          toTuesday: "",
          fromWednesday: "",
          toWednesday: "",
          fromThursday: "",
          toThursday: "",
          fromFriday: "",
          toFriday: "",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "",
          affiliation: "",
          affilType: "",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "-1",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "N",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "1350 Powell St, Norristown, PA, 19401",
          latitude: 40.124126,
          longitude: -75.33538,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 3.98
        }
      ],
      environmentId: "28",
      provId: "QMX000000084737",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Hospital", boardCertifiedFlag: "" }
      ],
      distanceInMiles: 3.98,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "QMX000000084737",
          primarySpecialty: "HOSPITAL",
          primarySpecialtyBoardCertified: false,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "QMX000000084737", affilType: "SERVICE", affiliateName: "RENAL CARE GROUP EAST INC", affiliateFax: null },
        { environmentId: "28", provId: "QMX000000084737", affilType: "DIRECT", affiliateName: "RENAL CARE GROUP EAST INC", affiliateFax: null }
      ],
      accreditations: [],
      hospitals: []
    },
    {
      lastName: "EY FORGE MEDICAL CENTER  and  HOSPITAL INC",
      firstName: "",
      providerDesignation: "",
      providerType: "HOSPITAL",
      provSex: "",
      provClass: "INSTITUTION",
      npi: "1528026671",
      email: "referrals@valleyforgemedical.com",
      url: "www.valley-forge-medical-and-hospital-administration.example-health-systems.com",
      language: "English, Interpreter Service",
      hospCred: "-1",
      stateLicenseNumber: "",
      specialTraining: "",
      ethnicity: "NO ETHNICITY",
      race: "",
      locations: [
        {
          planProvId: "TMP000000003168",
          provPhyAddr1: "1033 W Germantown Pike",
          provPhyAddr2: "",
          provPhyCity: "Norristown",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19403",
          phone: "(610) 539-8500 ",
          fromMonday: "",
          toMonday: "",
          fromTuesday: "",
          toTuesday: "",
          fromWednesday: "",
          toWednesday: "",
          fromThursday: "",
          toThursday: "",
          fromFriday: "",
          toFriday: "",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "",
          affiliation: "",
          affilType: "",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "0",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "N",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "1033 W Germantown Pike, Norristown, PA, 19403",
          latitude: 40.158671,
          longitude: -75.367631,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 4.5
        }
      ],
      environmentId: "28",
      provId: "TMP000000003168",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Hospital", boardCertifiedFlag: "" }
      ],
      distanceInMiles: 4.5,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "TMP000000003168",
          primarySpecialty: "HOSPITAL",
          primarySpecialtyBoardCertified: false,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "TMP000000003168", affilType: "DIRECT", affiliateName: "VALLEY FORGE MEDICAL CENTER  and  HOSPITAL INC", affiliateFax: null },
        { environmentId: "28", provId: "TMP000000003168", affilType: "SERVICE", affiliateName: "VALLEY FORGE MEDICAL CENTER  and  HOSPITAL INC", affiliateFax: null }
      ],
      accreditations: [],
      hospitals: []
    },
    {
      lastName: "UHS OF PENNSYLVANIA DBA THE HORSHAM CLINIC",
      firstName: "",
      providerDesignation: "",
      providerType: "GROUP OF PROVIDERS",
      provSex: "",
      provClass: "GROUP",
      npi: "1295708832",
      email: "intake@horshamclinic.uhs.com",
      url: "www.horshamclinic.uhs.com",
      language: "English, Interpreter Service",
      hospCred: "-1",
      stateLicenseNumber: "",
      specialTraining: "",
      ethnicity: "NO ETHNICITY",
      race: "",
      locations: [
        {
          planProvId: "QXIX00000243671",
          provPhyAddr1: "722 E Butler Pike",
          provPhyAddr2: "",
          provPhyCity: "Ambler",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19002",
          phone: "(215) 643-7800 ",
          fromMonday: "09:00 AM",
          toMonday: "04:00 PM",
          fromTuesday: "09:00 AM",
          toTuesday: "04:00 PM",
          fromWednesday: "09:00 AM",
          toWednesday: "04:00 PM",
          fromThursday: "09:00 AM",
          toThursday: "04:00 PM",
          fromFriday: "09:00 AM",
          toFriday: "04:00 PM",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "",
          affiliation: "UHS OF PENNSYLVANIA DBA THE HORSHAM CLINIC",
          affilType: "SERVICE",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "-1",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "N",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "722 E Butler Pike, Ambler, PA, 19002",
          latitude: 40.188062,
          longitude: -75.183655,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 5.47
        }
      ],
      environmentId: "28",
      provId: "QXIPQ0000103992",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Behavioral Health Facility", boardCertifiedFlag: "Yes" },
        { specialtyName: "Clinics Or Health Centers", boardCertifiedFlag: "Yes" },
        { specialtyName: "Hospital", boardCertifiedFlag: "" },
        { specialtyName: "Neurology", boardCertifiedFlag: "Yes" },
        { specialtyName: "Psychiatry", boardCertifiedFlag: "Yes" },
        { specialtyName: "Addiction Medicine", boardCertifiedFlag: "Yes" }
      ],
      distanceInMiles: 5.47,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "QXIPQ0000103992",
          primarySpecialty: "HOSPITAL",
          primarySpecialtyBoardCertified: false,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "QXIPQ0000103992", affilType: "DIRECT", affiliateName: "UHS OF PENNSYLVANIA DBA THE HORSHAM CLINIC", affiliateFax: null },
        { environmentId: "28", provId: "QXIPQ0000103992", affilType: "GROUP", affiliateName: "THE HORSHAM CLINIC", affiliateFax: null },
        { environmentId: "28", provId: "QXIPQ0000103992", affilType: "SERVICE", affiliateName: "UHS OF PENNSYLVANIA DBA THE HORSHAM CLINIC", affiliateFax: null }
      ],
      accreditations: [],
      hospitals: []
    },
    {
      lastName: "LANSDALE HOSPITAL CORPORATION",
      firstName: "",
      providerDesignation: "",
      providerType: "HOSPITAL",
      provSex: "",
      provClass: "INSTITUTION",
      npi: "1386896306",
      email: "admissions@lansdalehospital.com",
      url: "www.lansdale-hospital-corp-admissions-department.co",
      language: "English, Interpreter Service",
      hospCred: "-1",
      stateLicenseNumber: "",
      specialTraining: "",
      ethnicity: "NO ETHNICITY",
      race: "",
      locations: [
        {
          planProvId: "TMP000000003134",
          provPhyAddr1: "100 Medical Campus Dr",
          provPhyAddr2: "",
          provPhyCity: "Lansdale",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19446",
          phone: "(215) 481-4143 ",
          fromMonday: "",
          toMonday: "",
          fromTuesday: "",
          toTuesday: "",
          fromWednesday: "",
          toWednesday: "",
          fromThursday: "",
          toThursday: "",
          fromFriday: "",
          toFriday: "",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "",
          affiliation: "",
          affilType: "",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "-1",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "N",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "100 Medical Campus Dr, Lansdale, PA, 19446",
          latitude: 40.250094,
          longitude: -75.271415,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 5.88
        }
      ],
      environmentId: "28",
      provId: "TMP000000003134",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Hospital", boardCertifiedFlag: "" }
      ],
      distanceInMiles: 5.88,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "TMP000000003134",
          primarySpecialty: "HOSPITAL",
          primarySpecialtyBoardCertified: false,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "TMP000000003134", affilType: "SERVICE", affiliateName: "LANSDALE HOSPITAL CORPORATION", affiliateFax: null },
        { environmentId: "28", provId: "TMP000000003134", affilType: "DIRECT", affiliateName: "LANSDALE HOSPITAL CORPORATION", affiliateFax: null }
      ],
      accreditations: [],
      hospitals: []
    },
    // Type 1 (default/individual physician) — added so all 4 providerDetailsType
    // variants (see results.jsx's getProviderDetailsType/PROVIDER_TYPE_1..4 sets) are
    // represented in local dev dummy data, not just the hospital-heavy real PA sample
    // that was originally pasted (which only covered Type 2, plus one Type-1 fallback
    // via an unmatched "GROUP OF PROVIDERS" providerType).
    {
      lastName: "PATEL",
      firstName: "ANIKA",
      providerDesignation: "MD",
      providerType: "PHYSICIAN",
      provSex: "F",
      provClass: "INDIVIDUAL",
      npi: "1932456781",
      email: "a.patel@example.com",
      language: "English, Spanish",
      hospCred: "-1",
      stateLicenseNumber: "PA123456",
      specialTraining: "Cultural Competency Training",
      ethnicity: "NO ETHNICITY",
      race: "",
      locations: [
        {
          planProvId: "QXIPQ0000099001",
          provPhyAddr1: "200 Main St, Suite 3B",
          provPhyAddr2: "",
          provPhyCity: "Norristown",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19401",
          phone: "(610) 555-0142 ",
          fromMonday: "08:00 AM",
          toMonday: "05:00 PM",
          fromTuesday: "08:00 AM",
          toTuesday: "05:00 PM",
          fromWednesday: "08:00 AM",
          toWednesday: "05:00 PM",
          fromThursday: "08:00 AM",
          toThursday: "05:00 PM",
          fromFriday: "08:00 AM",
          toFriday: "01:00 PM",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "www.patelfamilymedicine.example.com",
          affiliation: "",
          affilType: "",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "-1",
          ageMin: "0",
          ageMax: "0",
          telehealth: "Yes",
          telehealthDaysHours: "Mon-Fri 9am-4pm",
          telemedicine: "Yes",
          ADA: {
            pubTrans: "YES",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "Y",
            handicapAccessibility: ""
          },
          agesServed: "0-99",
          formattedAddress: "200 Main St, Suite 3B, Norristown, PA, 19401",
          latitude: 40.121,
          longitude: -75.34,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 2.1
        }
      ],
      environmentId: "28",
      provId: "QXIPQ0000099001",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Family Medicine", boardCertifiedFlag: "Yes" }
      ],
      distanceInMiles: 2.1,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "QXIPQ0000099001",
          primarySpecialty: "Family Medicine",
          primarySpecialtyBoardCertified: true,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "QXIPQ0000099001", affilType: "GROUP", affiliateName: "PATEL FAMILY MEDICINE", affiliateFax: null },
        { environmentId: "28", provId: "QXIPQ0000099001", affilType: "HOSP STAFF", affiliateName: "EINSTEIN MEDICAL CENTER MONTGOMERY", affiliateFax: null }
      ],
      accreditations: [],
      hospitals: []
    },
    // Type 3 (clinic / facility) — providerType "CLINIC" is in results.jsx's
    // PROVIDER_TYPE_3 set.
    {
      lastName: "MONTGOMERY COUNTY URGENT CARE CLINIC",
      firstName: "",
      providerDesignation: "",
      providerType: "CLINIC",
      provSex: "",
      provClass: "INSTITUTION",
      npi: "1245789630",
      email: "urgentcare@mcuc-pa.net",
      language: "English, Interpreter Service",
      hospCred: "",
      stateLicenseNumber: "",
      specialTraining: "",
      ethnicity: "NO ETHNICITY",
      race: "",
      locations: [
        {
          planProvId: "QXIPQ0000099002",
          provPhyAddr1: "45 Ridge Pike",
          provPhyAddr2: "",
          provPhyCity: "Conshohocken",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19428",
          phone: "(610) 555-0198 ",
          fromMonday: "07:00 AM",
          toMonday: "09:00 PM",
          fromTuesday: "07:00 AM",
          toTuesday: "09:00 PM",
          fromWednesday: "07:00 AM",
          toWednesday: "09:00 PM",
          fromThursday: "07:00 AM",
          toThursday: "09:00 PM",
          fromFriday: "07:00 AM",
          toFriday: "09:00 PM",
          fromSaturday: "08:00 AM",
          toSaturday: "06:00 PM",
          fromSunday: "08:00 AM",
          toSunday: "06:00 PM",
          open24Hours: "",
          fax: "",
          url: "www.mcuc.example.com",
          affiliation: "MONTGOMERY COUNTY URGENT CARE CLINIC",
          affilType: "SERVICE",
          extendedOfficeHours: "Yes",
          extendedHoursFlag: "Yes",
          weekendHours: "Yes",
          newAssigns: "-1",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "YES",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "Y",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "45 Ridge Pike, Conshohocken, PA, 19428",
          latitude: 40.078,
          longitude: -75.301,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 6.2
        }
      ],
      environmentId: "28",
      provId: "QXIPQ0000099002",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Urgent Care", boardCertifiedFlag: "" }
      ],
      distanceInMiles: 6.2,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "QXIPQ0000099002",
          primarySpecialty: "CLINIC",
          primarySpecialtyBoardCertified: false,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "QXIPQ0000099002", affilType: "SERVICE", affiliateName: "MONTGOMERY COUNTY URGENT CARE CLINIC", affiliateFax: null }
      ],
      accreditations: [],
      hospitals: []
    },
    // Type 4 (DME / home & community-based services supplier) — providerType
    // "DME SUPPLIER" is in results.jsx's PROVIDER_TYPE_4 set.
    {
      lastName: "KEYSTONE HOME MEDICAL SUPPLY",
      firstName: "",
      providerDesignation: "",
      providerType: "DME SUPPLIER",
      provSex: "",
      provClass: "SUPPLIER",
      npi: "1367458920",
      email: "orders@keystonehomemedical.com",
      url: "www.keystone-home-medical-supply-equipment-rentals.example.org",
      language: "English",
      hospCred: "",
      stateLicenseNumber: "",
      specialTraining: "",
      ethnicity: "NO ETHNICITY",
      race: "",
      locations: [
        {
          planProvId: "QXIPQ0000099003",
          provPhyAddr1: "18 Commerce Dr",
          provPhyAddr2: "Unit 2",
          provPhyCity: "Plymouth Meeting",
          provPhyState: "PA",
          provPhyCounty: "Montgomery",
          provPhyZip: "19462",
          phone: "(610) 555-0176 ",
          fromMonday: "08:30 AM",
          toMonday: "04:30 PM",
          fromTuesday: "08:30 AM",
          toTuesday: "04:30 PM",
          fromWednesday: "08:30 AM",
          toWednesday: "04:30 PM",
          fromThursday: "08:30 AM",
          toThursday: "04:30 PM",
          fromFriday: "08:30 AM",
          toFriday: "04:30 PM",
          fromSaturday: "",
          toSaturday: "",
          fromSunday: "",
          toSunday: "",
          open24Hours: "",
          fax: "",
          url: "",
          affiliation: "",
          affilType: "",
          extendedOfficeHours: "",
          extendedHoursFlag: "No",
          weekendHours: "",
          newAssigns: "0",
          ageMin: "0",
          ageMax: "0",
          telehealth: "",
          telehealthDaysHours: "",
          telemedicine: "",
          ADA: {
            pubTrans: "NO",
            adjustableExamTable: "",
            accommodatesDeafnessHardOfHearing: "",
            accommodatesBlindVisuallyImpaired: "",
            accommodatesSpecialNeeds: "",
            examRoomMedicalEquipment: "",
            exteriorBuilding: "",
            interiorBuilding: "",
            parking: "",
            restrooms: "",
            handicapAccess: "N",
            handicapAccessibility: ""
          },
          agesServed: "Not available",
          formattedAddress: "18 Commerce Dr, Unit 2, Plymouth Meeting, PA, 19462",
          latitude: 40.108,
          longitude: -75.278,
          geocodeSource: "address_component_lookup",
          distanceInMiles: 7.9
        }
      ],
      environmentId: "28",
      provId: "QXIPQ0000099003",
      programId: "QMXHPQ0907",
      specialty: [
        { specialtyName: "Durable Medical Equipment", boardCertifiedFlag: "" }
      ],
      distanceInMiles: 7.9,
      primarySpecialty: [
        {
          environmentId: "28",
          provId: "QXIPQ0000099003",
          primarySpecialty: "DME SUPPLIER",
          primarySpecialtyBoardCertified: false,
          programId: "QMXHPQ0907"
        }
      ],
      affiliations: [
        { environmentId: "28", provId: "QXIPQ0000099003", affilType: "SERVICE", affiliateName: "KEYSTONE HOME MEDICAL SUPPLY", affiliateFax: null }
      ],
      accreditations: [],
      hospitals: []
    }
  ]
};


// ── Facets response (POST /hcb/v3/providersearch/providers/facet/search/retrieve) ──
export const dummyPaFacetsResponse = {
  totalProviders: 38,
  facets: [
    {
      key: "groupAffiliations",
      label: "Group affiliations",
      values: [
        "ABINGTON MEMORIAL HOSPITAL",
        "ALBERT EINSTEIN MEDICAL CENTER",
        "ARIA HEALTH",
        "ARIA HEALTH BUCKS COUNTY CAMPUS",
        "ARIA HEALTH FRANKFORD CAMPUS",
        "ARIA HEALTH PHYSICIAN SERVICES",
        "ARIA HEALTH PHYSICIANS SERVICES EMERGENCY MEDICINE",
        "CHESTER COUNTY HOSPITAL",
        "CHILDRENS HOSPITAL OF PHILADELPHIA",
        "CROZER CHESTER MEDICAL CENTER",
        "CROZER-CHESTER MEDICAL CENTER",
        "DOYLESTOWN HOSPITAL",
        "EINSTEIN MEDICAL CENTER MONTGOMERY",
        "FRIENDS BH SYSTEM",
        "KENSINGTON HOSPITAL",
        "LANSDALE HOSPITAL CORPORATION",
        "MAGEE REHABILITATION HOSPITAL",
        "MCMC MERCY FITZGERALD CAMPUS",
        "MERCY CATHOLIC MEDICAL CENTER OF SOUTHEASTERN PA",
        "METHODIST HOSPITAL",
        "NAZARETH HOSPITAL",
        "POTTSTOWN HOSPITAL LLC",
        "RENAL CARE GROUP EAST INC",
        "SHRINERS HOSPITALS FOR CHILDREN",
        "ST CHRISTOPHERS HOSPITAL FOR CHILDREN",
        "ST LUKES HOSPITAL GRAND VIEW CAMPUS",
        "ST MARY MEDICAL CENTER",
        "THE HORSHAM CLINIC",
        "THOMAS JEFFERSON UNIVERSITY HOSPITALS INC",
        "UHS OF PENNSYLVANIA DBA THE HORSHAM CLINIC",
        "VALLEY FORGE MEDICAL CENTER  and  HOSPITAL INC"
      ]
    },
    {
      key: "hospitalAffiliations",
      label: "Hospital affiliations",
      values: ["HAHNEMANN UNIVERSITY HOSPITAL"]
    },
    {
      key: "accreditation",
      label: "Accreditation",
      values: ["The Joint Commission"]
    },
    {
      key: "languagesSpoken",
      label: "Languages spoken",
      values: ["ENGLISH", "English", "Interpreter Service"]
    },
    {
      key: "specialties",
      label: "Specialties",
      values: [
        "Ambulatory Surgical Center",
        "Behavioral Health Facility",
        "Clinics Or Health Centers",
        "Home Health",
        "Hospital",
        "Neurology",
        "Occupational Therapy",
        "Physical Therapy",
        "Radiology",
        "Rehabilitation Center",
        "Rehabilitation Hospital",
        "Speech Therapy"
      ]
    },
    {
      key: "specialSkills",
      label: "Special skills",
      values: ["Cultural Competency Training"]
    }
  ]
};

// ── Plan features response (GET /hcb/v3/planfeature/plans/{envId}/features) ──
export const dummyPaPlanFeaturesResponse = {
  planFeatures: [
    {
      featureFlags: {
        providerCard: {
          distance: "Y",
          phone: "Y",
          address: "Y",
          website: "Y",
          acceptingNewPatients: "Y",
          boardCertified: "Y",
          handicapAccessible: "Y",
          virtualCareAvailable: "Y",
          boardCertifiedFlag: "Y",
          email: "N",
          newAssigns: "Y",
          providerDesignation: "Y",
          telemedicine: "Y"
        },
        providerDetails: {
          gender: "Y",
          boardCertifiedSpecialties: "Y",
          specialtiesNotBoardCertified: "Y",
          groupAffiliations: "Y",
          hospitalAffiliations: "Y",
          specialTraining: "Y",
          npid: "Y",
          stateLicenseNumber: "Y",
          fax: "N",
          ccbhcProvider: "Y",
          chronicIllness: "Y",
          cshcsProvider: "N",
          culturalCompetencyFlag: "Y",
          culturallyResponsiveCareChampion: "Y",
          culturallyResponsiveMaternalMentalHealth: "Y",
          culturallyResponsivePrimaryCareBehavioralHealth: "Y",
          endStateRenalDiseaseEsrd: "Y",
          ethnicity: "N",
          healthyAgingCareChampion: "Y",
          indianHealthServiceProvider: "Y",
          lgbtResponsiveCareChampion: "Y",
          matPrescribers: "Y",
          medicationAssistedTreatment: "Y",
          npi: "Y",
          pcmhCertification: "Y",
          personCenteredCareChampion: "Y",
          primarySpecialty: "Y",
          primarySpecialtyBoardCertified: "Y",
          provId: "Y",
          provSex: "Y",
          race: "N",
          rating: "Y",
          screeningBriefInterventionReferral: "Y",
          seriousMentalIllness: "Y",
          specialNeedsChildWelfare: "Y",
          specialNeedsSubstanceAbuse: "Y",
          specialNeedsTrauma: "Y",
          specializedExpertise: "Y",
          specialty: "Y",
          treatmentOfHepC: "Y",
          treatmentOfHivAids: "Y",
          vaccinesForChildren: "Y",
          womensHealthCareChampion: "Y",
          birthFriendly: "N",
          visitType: "Y"
        },
        serviceLocations: {
          facilityName: "Y",
          distance: "Y",
          phone: "Y",
          address: "Y",
          website: "Y",
          acceptingNewPatients: "Y",
          hoursOfOperation: "Y",
          virtualCareOffered: "Y",
          handicapAccessible: "Y",
          publicTransportation: "Y",
          allProvidersEnglish: "Y",
          accommodatesBlindVisuallyImpaired: "Y",
          accommodatesDeafnessHardOfHearing: "Y",
          accommodatesSpecialNeeds: "Y",
          accreditingOrgName: "Y",
          accreditingOrgUrl: "Y",
          affilType: "Y",
          affiliateFax: "Y",
          affiliateName: "Y",
          affiliation: "Y",
          afterHoursContactInfo: "Y",
          ageMax: "Y",
          ageMin: "Y",
          asamlocDescriptions: "Y",
          culturalCompetencyTraining: "Y",
          examRoomMedicalEquipment: "Y",
          extendedOfficeHours: "Y",
          exteriorBuilding: "Y",
          fax: "Y",
          fromFriday: "Y",
          fromMonday: "Y",
          fromSaturday: "Y",
          fromSunday: "Y",
          fromThursday: "Y",
          fromTuesday: "Y",
          fromWednesday: "Y",
          handicapAccess: "Y",
          handicapAccessibility: "Y",
          hospCred: "Y",
          interiorBuilding: "Y",
          language: "Y",
          newAssigns: "Y",
          parking: "Y",
          provPhyAddr1: "Y",
          provPhyAddr2: "Y",
          provPhyCity: "Y",
          provPhyCounty: "Y",
          provPhyState: "Y",
          provPhyZip: "Y",
          pubTrans: "Y",
          restrooms: "Y",
          specialNeedsChronicIllness: "Y",
          specialNeedsCooccurringDisorders: "Y",
          specialNeedsDeafHardOfHearing: "Y",
          specialNeedsHomelessness: "Y",
          splNeeds1: "Y",
          splNeeds2: "Y",
          telehealth: "Y",
          telehealthDaysHours: "Y",
          telemedicine: "Y",
          toFriday: "Y",
          toMonday: "Y",
          toSaturday: "Y",
          toSunday: "Y",
          toThursday: "Y",
          toTuesday: "Y",
          toWednesday: "Y",
          url: "Y",
          weekendHours: "Y",
          Open24Hours: "N"
        },
        filters: {
          distance: "Y",
          newPatientStatus: "Y",
          visitType: "Y",
          gender: "Y",
          languagesSpoken: "Y",
          agesServed: "Y",
          handicapAccessibility: "Y",
          groupAffiliations: "Y",
          hospitalAffiliations: "Y",
          specialties: "Y",
          specializedTraining: "Y",
          afterHoursWeekend: "N",
          boardCertification: "Y",
          accreditation: "Y",
          pubTrans: "Y",
          cshcsProvider: "N",
          birthFriendly: "N",
          race: "N",
          ethnicity: "Y"
        }
      },
      updatedAt: "2026-04-10T15:02:52.627+00:00",
      updatedBy: "kulkarniv3@aetna.com",
      environmentId: "28",
      planName: "PA",
      planDescription: "Pennsylvania",
      environmentActive: "yes",
      centralZip: 19422,
      contactUsURL: "https://www.aetnabetterhealth.com/pennsylvania/contact-us.html",
      privacyPolicyURL: "https://www.aetnabetterhealth.com/pennsylvania/footers/privacy.html",
      legalStatementURL: "https://www.aetnabetterhealth.com/pennsylvania/footers/legal-statement.html",
      nonDiscriminationNoticeURL: "https://www.aetnabetterhealth.com/pennsylvania/notice-of-non-discrimination.html",
      logoRedirectURL: "https://www.aetnabetterhealth.com/pennsylvania/index.html",
      printDirectoryURL: "https://www.aetnabetterhealth.com/pennsylvania/provider-directory.html",
      browseByCategories: "Types of care | Places of care",
      popularSearch: [
        { psName: "Child health", psId: "28CHH" },
        { psName: "Behavioral and mental health", psId: "28BMH" },
        { psName: "Primary and preventive care", psId: "28PPC" },
        { psName: "Hospitals", psId: "28HOS" },
        { psName: "Home and Community-Based Care", psId: "28HCB" }
      ],
      typeOfCare: "",
      placesOfCare: "",
      planType: [],
      planCode: [],
      footerText: "Copyright © Aetna Better Health of Pennsylvania, All Rights Reserved.",
      moreProviderInfo: "NA",
      allowedLanguages: ["English", "Spanish"]
    }
  ]
};

// ── Browse-by / specialties response (GET /hcb/v3/planspecialty/plans/{envId}/specialties) ──
export const dummyPaBrowseByResponse = {
  browseBy: [
    {
      environmentId: "28",
      planName: "PA",
      browseByCategories: {
        healthConditions: [
          "Cancer",
          "Congestive heart failure (CHF)",
          "Coronary artery disease (CAD)",
          "Diabetes",
          "Kidney disease"
        ],
        typesOfCare: [
          "Behavioral and mental health (psychology and psychiatry)",
          "Child health (pediatrics)",
          "Dental and oral health",
          {
            lookingForText: "I'm looking for:",
            subCategories: [
              {
                subCategory: "Medical, surgical, specialty of emergency dental care",
                description: "Get care for serious medical conditions related to your teeth, gums and mouth"
              },
              {
                subCategory: "Routine dental care (routine check-ups, X-rays, fillings)",
                externalLink: "https://aetnapamwp.sciondental.com/MWP/Landing",
                description: "Get care for the general health of your teeth, gums and mouth"
              }
            ]
          },
          "Emergency and urgent care",
          {
            lookingForText: "I'm looking for:",
            subCategories: [
              {
                subCategory: "Emergency Care",
                description: "Use this care if you need help right away. Some signs are chest pain, trouble breathing or heavy bleeding. It's the best option when a situation threatens a life."
              },
              {
                subCategory: "Urgent Care",
                description: "Use this care if you need help soon. Some examples are sprains, small cuts, flu or ear infections. It's a good option when you can't wait to see your regular doctor."
              }
            ]
          },
          "Home and Community-Based Care (Long-Term Services and Supports)",
          "Pregnancy and women\u2019s health (obstetrics and gynecology)",
          "Primary and preventive care (general practice)",
          "Skin health (dermatology)",
          "Therapy (except mental health counseling)",
          "Thinking and learning (intellectual and developmental) disabilities",
          "Vision health (optometry and ophthalmology)",
          {
            lookingForText: "I'm looking for:",
            subCategories: [
              { subCategory: "Medical, surgical, specialty or emergency vision care" },
              {
                subCategory: "Routine vision care (check-ups, glasses, contacts)",
                description: "Get care for the general health of your eyes and vision"
              }
            ]
          },
          "X-rays and imaging (radiology and nuclear medicine)"
        ],
        whereToGetCare: [
          "Assisted-living facilities (Home and Community-Based Care)",
          "Behavioral health center (mental health and substance use disorders)",
          "Birth-care centers",
          "Custodial nursing facilities (Long-Term Services and Supports)",
          "Dialysis centers",
          "Emergency and urgent care",
          {
            lookingForText: "I'm looking for:",
            subCategories: [
              {
                subCategory: "Emergency Care",
                description: "Use this care if you need help right away. Some signs are chest pain, trouble breathing or heavy bleeding. It's the best option when a situation threatens a life."
              },
              {
                subCategory: "Urgent Care",
                description: "Use this care if you need help soon. Some examples are sprains, small cuts, flu or ear infections. It's a good option when you can't wait to see your regular doctor."
              }
            ]
          },
          "Hospitals",
          "Labs (testing)",
          {
            // "Quick links" panel example (see browseBy.jsx's isQuickLinksSection) — a
            // 3-element lookingForText: [0] the standard overlay label, [1]/[2] the two
            // section headers rendered inside the panel body ("More Results" then
            // "Quick links", read in reverse display order). subCategories mixes the
            // external provider links (LabCorp, Quest Diagnostics — displayed in this
            // same, alphabetical order) with one link-less entry ("Find more lab
            // providers") that becomes the "More Results" section's own placeholder
            // link instead of a plain header.
            lookingForText: ["I'm looking for:", "More Results", "Quick links"],
            subCategories: [
              {
                subCategory: "Find more lab providers",
                description: "Get options for both routine and specialty lab work:"
              },
              {
                subCategory: "LabCorp",
                externalLink: "https://www.labcorp.com/patients/labs-and-appointments",
                description: "Get locations and make appointments for these providers."
              },
              {
                subCategory: "Quest Diagnostics",
                externalLink: "https://www.questdiagnostics.com/locations/search"
              }
            ]
          },
          "Pharmacies",
          {
            externalLink: "https://www.caremark.com/account-login/look-up?targetUrl=https%3A%2F%2Fwww.caremark.com%2Fpharmacy%2Fbenefits%2Ffast%2Foe%2Fpharmacy-locator%2Fsearch%3FfastStyle%3DOE%26oeFillDate%3DAUTO(01%252F01%252F2025)%26BlocksTenant%3Dnull"
          },
          "Physical therapy centers",
          "Skilled nursing facilities",
          "Walk-in clinics"
        ]
      }
    }
  ]
};

// ── Fuzzy (type-ahead) search response (GET /hcb/v3/.../fuzzysearch or similar) ──
// Shape matches searchBar.jsx's categorizeResults() exactly: { provider, typesOfCare,
// whereToGetCare, allresult, healthConditions }.
export const dummyPaFuzzySearchResponse = {
  provider: [
    {
      externalLink: null,
      environmentId: "28",
      provId: "TMP000000007703",
      lastName: "ALBERT EINSTEIN MEDICAL CENTER",
      firstName: "",
      specialty: ["Hospital", "Rehabilitation Center", "Rehabilitation Hospital"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "QXIPQ0000122999",
      lastName: "MERCY CATHOLIC MEDICAL CENTER OF SOUTHEASTERN PA",
      firstName: "",
      specialty: ["Hospital", "Rehabilitation Hospital"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "TMP000000003060",
      lastName: "DOYLESTOWN HOSPITAL",
      firstName: "",
      specialty: ["Hospital"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "QMX000000066225",
      lastName: "KENSINGTON HOSPITAL",
      firstName: "",
      specialty: ["Hospital", "Radiology"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "TMP000000005458",
      lastName: "METHODIST HOSPITAL",
      firstName: "",
      specialty: ["Hospital"]
    }
  ],
  typesOfCare: [
    {
      environmentId: "28",
      provId: null,
      lastName: null,
      firstName: null,
      specialty: ["Hospital"],
      externalLink: null,
      externalLinkValue: null,
      externalLinkDesc: null
    },
    {
      environmentId: "28",
      provId: null,
      lastName: null,
      firstName: null,
      specialty: ["Rehabilitation Hospital"],
      externalLink: null,
      externalLinkValue: null,
      externalLinkDesc: null
    }
  ],
  whereToGetCare: [
    { environmentId: "28", provId: null, lastName: null, firstName: null, specialty: ["Hospital"] },
    { environmentId: "28", provId: null, lastName: null, firstName: null, specialty: ["Rehabilitation Hospital"] }
  ],
  allresult: [
    {
      externalLink: null,
      environmentId: "28",
      provId: "TMP000000007703",
      lastName: "ALBERT EINSTEIN MEDICAL CENTER",
      firstName: "",
      specialty: ["Hospital", "Rehabilitation Center", "Rehabilitation Hospital"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "QXIPQ0000122999",
      lastName: "MERCY CATHOLIC MEDICAL CENTER OF SOUTHEASTERN PA",
      firstName: "",
      specialty: ["Hospital", "Rehabilitation Hospital"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "TMP000000003060",
      lastName: "DOYLESTOWN HOSPITAL",
      firstName: "",
      specialty: ["Hospital"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "QMX000000066225",
      lastName: "KENSINGTON HOSPITAL",
      firstName: "",
      specialty: ["Hospital", "Radiology"]
    },
    {
      externalLink: null,
      environmentId: "28",
      provId: "TMP000000005458",
      lastName: "METHODIST HOSPITAL",
      firstName: "",
      specialty: ["Hospital"]
    },
    { environmentId: "28", provId: null, lastName: null, firstName: null, specialty: ["Hospital"] },
    { environmentId: "28", provId: null, lastName: null, firstName: null, specialty: ["Rehabilitation Hospital"] },
    { environmentId: "28", provId: null, lastName: null, firstName: null, specialty: ["Hospital"] },
    { environmentId: "28", provId: null, lastName: null, firstName: null, specialty: ["Rehabilitation Hospital"] }
  ],
  healthConditions: []
};
